import React from "react";

const CertificateSection: React.FC = () => {
	return (
		<section id="certificado" className="py-16 bg-gray-50">
			<div className="mt-4">
				<div className="w-full transform transition-all duration-1000 translate-y-0 opacity-100">
					<div className="bg-white shadow-lg overflow-hidden rounded-xl">
						<div className="bg-green-500 p-6 text-center relative overflow-hidden">
							{/* Manchas decorativas em verde mais claro */}
							<div className="absolute top-0 left-0 w-32 h-32 bg-green-300/30 rounded-full -translate-x-16 -translate-y-16"></div>
							<div className="absolute top-4 right-8 w-20 h-20 bg-green-400/40 rounded-full"></div>
							<div className="absolute bottom-0 right-0 w-40 h-40 bg-green-300/25 rounded-full translate-x-20 translate-y-20"></div>
							<div className="absolute bottom-4 left-12 w-16 h-16 bg-green-400/35 rounded-full"></div>

							<div className="relative z-10">
								<div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
									<i className="ri-video-chat-line text-white text-2xl"></i>
								</div>
								<h2
									className="text-2xl font-bold text-white mb-2"
									style={{
										fontFamily: "DM Sans, sans-serif",
									}}
								>
									Certificado Digital
								</h2>
								<p className="text-green-100">
									Emissão rápida e segura por videochamada.
									Processo 100% digital para sua comodidade.
								</p>
							</div>
						</div>

						<div className="p-8">
							<div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
								<div className="text-center">
									<div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mx-auto mb-4">
										<i className="ri-time-line text-blue-600 text-2xl"></i>
									</div>
									<h4 className="font-bold text-gray-800 mb-2 text-lg">
										Apenas 5 minutos
									</h4>
									<p className="text-gray-600 text-base">
										Videochamada rápida e eficiente
									</p>
								</div>

								<div className="text-center">
									<div className="w-16 h-16 bg-green-100 rounded-lg flex items-center justify-center mx-auto mb-4">
										<i className="ri-smartphone-line text-green-600 text-2xl"></i>
									</div>
									<h4 className="font-bold text-gray-800 mb-2 text-lg">
										Pelo celular
									</h4>
									<p className="text-gray-600 text-base">
										Sem complicação, de qualquer lugar
									</p>
								</div>

								<div className="text-center">
									<div className="w-16 h-16 bg-purple-100 rounded-lg flex items-center justify-center mx-auto mb-4">
										<i className="ri-check-double-line text-purple-600 text-2xl"></i>
									</div>
									<h4 className="font-bold text-gray-800 mb-2 text-lg">
										Sem complicações
									</h4>
									<p className="text-gray-600 text-base">
										Processo simples e descomplicado
									</p>
								</div>
							</div>

<div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
  {/* Card 1 - Certificado A1 CPF */}
  <a
    href="https://wa.me/5512974036221"
    target="_blank"
    rel="noopener noreferrer"
    className="block bg-blue-50 rounded-lg p-6 text-center border border-blue-200 hover:shadow-lg transition-shadow duration-300"
  >
    <div className="mb-4">
      <img
        src="https://static.readdy.ai/image/908bbe08831e926531d801313f7e211b/134093a619944578e7fa266f95493f83.png"
        alt="Certificado Digital e-CPF"
        className="w-40 h-24 object-contain mx-auto"
      />
    </div>
    <h4 className="font-bold text-gray-800 text-xl mb-2">Certificado A1 CPF</h4>
    <p className="text-gray-600 mb-3 text-base">Para pessoas físicas</p>
    <div className="text-xl font-bold text-blue-600 mb-2">R$ 150,00</div>
    <p className="text-gray-500 mb-3 text-base">Validade: 1 ano</p>
    <div className="bg-white rounded-lg p-3 text-sm text-gray-600">
      <i className="ri-information-line mr-2"></i>Ideal para MEI
    </div>
  </a>

  {/* Card 2 - Certificado A1 CNPJ */}
  <a
    href="https://wa.me/5512974036221"
    target="_blank"
    rel="noopener noreferrer"
    className="block bg-orange-50 rounded-lg p-6 text-center border border-orange-200 hover:shadow-lg transition-shadow duration-300"
  >
    <div className="mb-4">
      <img
        src="https://static.readdy.ai/image/908bbe08831e926531d801313f7e211b/f2c39d5d5d626bfa1fa762887c6e406f.png"
        alt="Certificado Digital e-CNPJ"
        className="w-40 h-24 object-contain mx-auto"
      />
    </div>
    <h4 className="font-bold text-gray-800 text-xl mb-2">Certificado A1 CNPJ</h4>
    <p className="text-gray-600 mb-3 text-base">Para pessoas jurídicas</p>
    <div className="text-xl font-bold text-orange-600 mb-2">R$ 220,00</div>
    <p className="text-gray-500 mb-3 text-base">Validade: 1 ano</p>
    <div className="bg-white rounded-lg p-3 text-sm text-gray-600">
      <i className="ri-information-line mr-2"></i>Para empresas de todos os portes
    </div>
  </a>
</div>



							<div className="text-center px-4">
								<a
									href="https://wa.me/5512974036221"
									target="_blank"
									rel="noopener noreferrer"
									className="inline-flex items-center justify-center w-full sm:w-auto px-6 sm:px-8 py-4 bg-green-500 text-white font-bold rounded-lg hover:bg-green-600 transition-all duration-300 shadow-lg text-base sm:text-lg gap-2"
								>
									<i className="ri-whatsapp-line text-2xl sm:text-xl"></i>
									<span className="whitespace-normal sm:whitespace-nowrap text-center">
										Solicitar Certificado Digital
									</span>
								</a>
								<p className="text-gray-500 mt-3 text-sm sm:text-base">
									Clique para iniciar o processo via WhatsApp
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default CertificateSection;
